import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius4, colorBgBase, space16, space8, space6, space12 } = theme();

  return StyleSheet.create({
    container: {
      backgroundColor: colorBgBase,
    },
    containerLarge: {
      marginRight: space16,
      paddingBottom: space6,
      paddingHorizontal: space8,
      paddingTop: space8,
    },
    detailLarge: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
      padding: space6,
    },

    detailSmall: {
      backgroundColor: colorBgBase,
    },
    detailWrapperLarge: {
      marginBottom: space12,
    },
    layout: {
      paddingVertical: space12,
    },
  });
};

export { style };
